import { createEntityAdapter, EntityAdapter, EntityState, Update } from "@ngrx/entity";
import { UsuarioCumple, MensajeCumple, UsuarioCumpleFoto, CumpleFilterDates, UsuarioFuncion } from "src/common/cumples";
import { CumplesActions, CumplesActionTypes } from "./cumples.actions";

export interface CumplesState extends EntityState<UsuarioCumple> {
	ready: boolean,
	envioReady: boolean,
	usuariosFoto: UsuarioCumpleFoto
	filter: {
		ready: boolean,
		actualDate: string,
		dates: CumpleFilterDates
	},
	info: {
		idUsuarioMf: number,
		funciones: UsuarioFuncion[],
		ready: boolean
	}
}

export const cumplesAdapter: EntityAdapter<UsuarioCumple> = createEntityAdapter<UsuarioCumple>({
	selectId: (cumple: UsuarioCumple) => cumple.idUsuarioMf
});

const initialCumplesState: CumplesState = cumplesAdapter.getInitialState({
	ready: true,
	envioReady: true,
	usuariosFoto: null,
	filter: {
		ready: true,
		actualDate: null,
		dates: null
	},
	info: {
		idUsuarioMf: null,
		funciones: null,
		ready: true
	}
});

export function cumplesReducer( state: CumplesState = initialCumplesState, action: CumplesActions ): CumplesState {
	let idUsuarioMf: number = null;
	switch( action.type ) {
		case CumplesActionTypes.CumplesClearRequested:
			return initialCumplesState;

		// Listado related actions
		case CumplesActionTypes.CumplesRequested:
			return cumplesAdapter.removeAll( { ...state, ready: false, usuariosFoto: null } );
		case CumplesActionTypes.CumplesLoaded:
			let cumples: UsuarioCumple[] = action["payload"]["cumples"];
			return cumplesAdapter.setAll( cumples, { ...state, ready: true } );
		case CumplesActionTypes.CumplesCancelled:
			return { ...state, ready: true };

		// Mensaje related actions
		case CumplesActionTypes.MensajeCumpleRequested:
			return { ...state, envioReady: false };
		case CumplesActionTypes.MensajeCumpleCreated:
			let mensajeCumple: MensajeCumple = action["payload"];
			const cumpleUpdate: Update<UsuarioCumple> = {
				id: mensajeCumple.recibeIdUsuarioMf,
				changes: { fechaUltimoMensajeAsDesc: mensajeCumple.fechaAltaAsDesc }
			};
			return cumplesAdapter.updateOne( cumpleUpdate, { ...state, envioReady: true } );
		case CumplesActionTypes.MensajeCumpleCancelled:
			return { ...state, envioReady: true };

		// Foto related actions
		case CumplesActionTypes.UsuarioFotoRequested:
			idUsuarioMf = action["payload"]["idUsuarioMf"];
			return { ...state, usuariosFoto: { ...state.usuariosFoto, [idUsuarioMf]: { foto: null, found: null } } };
		case CumplesActionTypes.UsuarioFotoLoaded:
			let payload: any = action["payload"];
			idUsuarioMf = payload["idUsuarioMf"];
			let foto: string = payload["foto"];
			return { ...state, usuariosFoto: { ...state.usuariosFoto, [idUsuarioMf]: { foto, found: true } } };
		case CumplesActionTypes.UsuarioFotoCancelled:
			idUsuarioMf = action["payload"]["idUsuarioMf"];
			return { ...state, usuariosFoto: { ...state.usuariosFoto, [idUsuarioMf]: { foto: null, found: false } } };
		case CumplesActionTypes.UsuarioFotoDoNothing:
			return state;

		// Filter related actions
		case CumplesActionTypes.CumplesInitFilterRequested:
			return { ...state, filter: { ...state.filter, ready: false } };
		case CumplesActionTypes.CumplesInitFilterLoaded:
			let dates: CumpleFilterDates = action["payload"]["filterDates"];
			return { ...state, filter: { ...state.filter, dates, ready: true } };
		case CumplesActionTypes.CumplesInitFilterCancelled:
			return { ...state, filter: { ...state.filter, ready: true } };
		case CumplesActionTypes.CumplesFilterChangeDone:
			let actualDate: string = action["payload"]["date"];
			return { ...state, filter: { ...state.filter, actualDate } };

		// Funciones related actions
		case CumplesActionTypes.UsuarioFuncionesRequested:
			idUsuarioMf = action["payload"]["idUsuarioMf"];
			return { ...state, info: { ...state.info, ready: idUsuarioMf == state.info.idUsuarioMf } };
		case CumplesActionTypes.UsuarioFuncionesLoaded:
			let funciones: UsuarioFuncion[] = action["payload"]["funciones"];
			idUsuarioMf = action["payload"]["idUsuarioMf"];
			return { ...state, info: { ...state.info, idUsuarioMf, funciones, ready: true } };
		case CumplesActionTypes.UsuarioFuncionesCancelled:
			return { ...state, info: { ...state.info, ready: true } };

		default:
			return state;
	}
}

export const {
	selectAll,
	selectEntities,
	selectIds,
	selectTotal
} = cumplesAdapter.getSelectors();

